import { Apis } from "libs/apis";
import Swal from "sweetalert2";

interface UpdatePasswordBody {
  currentPassword: string;
  newPassword: string;
}
export const useUpdatePassword = () => {
  const updatePassword = async (body: UpdatePasswordBody) => {
    try {
      const res = await Apis.updatePassword(body);
       Swal.fire({
          title: "Success!",
          text: res.data.message,
          icon: "success",
        });
      
    } catch (error: any) {
      Swal.fire({
          title: "Error",
          text: error.response?.data?.error,
          icon: "error",
        });
    }
  };
  return { updatePassword };
};
